import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { NavService } from '../../_services/_nav.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { ProductoTroncalService } from '../../_services/producto-troncal.service';
import { ProductoTroncal } from '../../_models/producto-troncal';

@Component({
  selector: 'app-productos-troncal',
  templateUrl: './productos-troncal.component.html',
  styleUrls: ['./productos-troncal.component.css']
})
export class ProductosTroncalComponent implements OnInit {

  productosTroncal: ProductoTroncal[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  minorden = 0;
  maxorden = 0;

  /**
   * Base64 (sanitizado) de cada ícono, indexado por idProductoTroncal.
   * Ausencia de entrada = sin ícono cargado (fallback en el template).
   */
  iconosBase64: { [idProductoTroncal: string]: SafeResourceUrl } = {};

  constructor( private productoTroncalServicio: ProductoTroncalService,
               private adjuntoServicio: AdjuntoService,
               private sanitizer: DomSanitizer,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/productos-troncal' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PRODUCTOSTRONCAL.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PRODUCTOSTRONCAL.LBL_NOMBRE' ), sort: false },
      { field: 'indicadorProducto', header: this.navServicio.buscarMensaje( 'PRODUCTOSTRONCAL.LBL_PRODUCTO' ), sort: false },
      { field: 'tipoProducto', header: this.navServicio.buscarMensaje( 'PRODUCTOSTRONCAL.LBL_TIPO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'nombreAdjuntoIcono', header: this.navServicio.buscarMensaje( 'PRODUCTOSTRONCAL.LBL_ICONO' ), sort: false },
      { field: 'orden', header: this.navServicio.buscarMensaje( 'LBL_ORDEN' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'productos-troncal.component' );

    this.productoTroncalServicio.listado().subscribe( productosTroncal => {
      productosTroncal = productosTroncal.sort( ( a, b ) => a.orden - b.orden );
      this.productosTroncal = productosTroncal;
      this.minorden = this.productosTroncal.length > 0 ? this.productosTroncal[ 0 ].orden : 0;
      this.maxorden = this.productosTroncal.length > 0 ? this.productosTroncal[ this.productosTroncal.length - 1 ].orden : 0;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
      this.cargarIconos( productosTroncal );
    } );
  }

  /**
   * Intercambia el orden entre la fila actual y su vecina (arriba/abajo) y
   * persiste ambas, igual que ProductoListadoComponent.changeorder().
   * @param tipo -1 = subir, 1 = bajar
   */
  cambiarOrden( tipo: number, productoTroncal: ProductoTroncal ) {
    const indice = this.productosTroncal.indexOf( productoTroncal ) + tipo;
    const vecino = this.productosTroncal[ indice ];
    const ordenActual = productoTroncal.orden;
    const ordenVecino = vecino.orden;
    productoTroncal.orden = ordenVecino;
    vecino.orden = ordenActual;
    this.actualizarOrden( vecino );
    this.actualizarOrden( productoTroncal );
    this.productosTroncal = this.productosTroncal.sort( ( a, b ) => a.orden - b.orden );
    this.minorden = this.productosTroncal[ 0 ].orden;
    this.maxorden = this.productosTroncal[ this.productosTroncal.length - 1 ].orden;
  }

  actualizarOrden( productoTroncal: ProductoTroncal ) {
    this.productoTroncalServicio.actualizar( productoTroncal ).subscribe( () => {
      this.navServicio.setMesage( 2 );
    }, () => {
      this.navServicio.setMesage( 3 );
    } );
  }

  /**
   * Descarga el ícono (adjunto) de cada producto troncal y lo convierte a
   * base64 para pintarlo en la tabla, siguiendo el mismo mecanismo que
   * MenusComponent.cargarAdjunto(): descargarArchivo (blob) + FileReader.
   */
  cargarIconos( productosTroncal: ProductoTroncal[] ) {
    productosTroncal
      .filter( p => !!p.idIcono )
      .forEach( p => {
        this.adjuntoServicio.descargarArchivo( p.idIcono ).subscribe( blob => {
          if ( !blob || blob.size === 0 ) {
            return;
          }
          const reader = new FileReader();
          reader.addEventListener( 'load', () => {
            this.iconosBase64[ p.idProductoTroncal ] = this.sanitizer.bypassSecurityTrustUrl( reader.result.toString() );
          }, false );
          reader.readAsDataURL( blob );
        } );
      } );
  }

  crear() {
    this.router.navigate( [ 'apl/productos-troncal/agregar' ] );
  }

  ver( regVisualizar: ProductoTroncal ) {
    this.router.navigate( [ 'apl/productos-troncal/detalle/' + regVisualizar.idProductoTroncal ] );
  }

  editar( regActualizar: ProductoTroncal ) {
    this.router.navigate( [ 'apl/productos-troncal/actualizar/' + regActualizar.idProductoTroncal ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'productos-troncal.component', this.busqueda );
  }
}
